<template>
  <!-- 投資型基本輸入：版型三　躉繳VL -->
  <div>
    <div class="row mt_16"><div class="col create_title">規劃保費與保額</div></div>
    <!-- 保費 -->
    <div class="form-group d-flex align-items-end mt_20">
      <div class="d-flex text-norwap mr_8">
        <strong style="line-height: 40px">規劃保費:</strong>
      </div>
      <div class="d-flex align-items-center mr_8">
        <!-- 繳別 -->
        <label>繳別:</label>
        <select
          class="form-control"
          style="width: 8rem"
          :id="'pay_freq'"
          data-vv-name="pay_freq"
          :class="{ 'is-invalid': errors.has('pay_freq') }"
          v-validate="`required`"
          data-vv-as="繳別"
          v-model="productDataScope.pay_freq"
          @change="getINVAmtLimitRanges()"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(payFreqOption, index) in option.payFreq_option"
            :key="index.paraval"
            :value="payFreqOption.paraval"
          >
            {{ payFreqOption.paradetlno }}
          </option>
        </select>
      </div>
      <!-- 保費 -->
      <div class="d-flex align-items-center mr_8">
        <div style="line-height: 40px" class="mr_4">保費:</div>
        <div class="position-relative">
          <div
            class="notice-top text-red"
            v-if="PRODUCT_FEATURE_DATA.face_prem_incr_unit != '0'"
          >
            {{
              `需以${formatMethods(
                PRODUCT_FEATURE_DATA.face_prem_incr_unit
              )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
            }}
          </div>
          <div class="d-flex align-items-center">
            <input
              type="tel"
              class="form-control mr_2"
              style="width: 175px"
              :class="{ 'is-invalid': errors.has('premium') }"
              :id="'premium'"
              :data-vv-name="'premium'"
              v-validate="`required|premium`"
              data-vv-as="保費"
              @input="
                numberHandler(productDataScope, 'premium', $event);
                getINVAmtLimitRanges();
              "
              @blur="numberHandler(productDataScope, 'premium', $event)"
              :value="productDataScope.premium | formatMethods"
              @change="productDataScope.amt && $validator.validate(`amt`)"
              :placeholder="
                productDataScope.pay_freq &&
                prem_limit[productDataScope.pay_freq]
                  ? `${formatMethods(
                      converIncrUnit(
                        prem_limit[productDataScope.pay_freq].prem_floor
                      )
                    )}~${
                      prem_limit[productDataScope.pay_freq].prem_ceil < 0
                        ? '無上限'
                        : formatMethods(
                            converIncrUnit(
                              prem_limit[productDataScope.pay_freq].prem_ceil
                            )
                          )
                    }`
                  : ''
              "
            />
          </div>
        </div>
        <span>{{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}</span>
      </div>
    </div>
    <!-- 基本保額 -->
    <div class="form-group d-flex align-items-end mt_20">
      <div class="d-flex mr_8">
        <strong style="line-height: 40px">基本保額:</strong>
      </div>

      <div class="d-flex flex-column align-items-start">
        <div
          class="notice-top text-red"
          style="left: 20px; text-align: left"
          v-if="
            PRODUCT_FEATURE_DATA.amt_incr_unit !== '0' &&
            PRODUCT_FEATURE_DATA.amt_incr_unit / amt_formatVal != 1 &&
            !(
              PRODUCT_FEATURE_DATA.amt_unit == '7' ||
              PRODUCT_FEATURE_DATA.amt_unit == '8' ||
              PRODUCT_FEATURE_DATA.col_amt == '1'
            )
          "
        >
          {{
            `需以${formatMethods(
              PRODUCT_FEATURE_DATA.amt_incr_unit / amt_formatVal
            )}${
              PRODUCT_FEATURE_DATA.amt_unit_nm.indexOf("元") != -1
                ? ""
                : PRODUCT_FEATURE_DATA.amt_unit_nm
            }${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
          }}
        </div>
        <div class="d-flex align-items-center">
          <input
            type="tel"
            class="form-control mr_2"
            style="width: 10rem"
            :class="{ 'is-invalid': errors.has('amt') }"
            :id="'amt'"
            :data-vv-name="'amt'"
            v-validate="`required|amt`"
            data-vv-as="基本保額"
            @input="numberHandler(productDataScope, 'amt', $event)"
            @blur="numberHandler(productDataScope, 'amt', $event)"
            :value="productDataScope.amt | formatMethods"
            :placeholder="
              amt_limit
                ? `${formatMethods(amt_limit.amt_floor)}~${
                    amt_limit.amt_ceil <= 0
                      ? '無上限'
                      : formatMethods(amt_limit.amt_ceil)
                  }`
                : ''
            "
          />
          <span>{{
            unit_curr(PRODUCT_FEATURE_DATA.amt_unit, PRODUCT_FEATURE_DATA.curr)
          }}</span>
        </div>
      </div>
      <!-- <div class="col-8 align-items-center">
        <div class="yearPremiumLimit" v-if="yearPremiumLimit">
          基本保額的年繳化目標保費上下限:
          {{
            `${formatMethods(yearPremiumLimit.prem_floor)}
            ${currTranser(PRODUCT_FEATURE_DATA.curr, true)}~
            ${formatMethods(yearPremiumLimit.prem_ceil)}
            ${currTranser(PRODUCT_FEATURE_DATA.curr, true)}`
          }}
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import { Validator } from "vee-validate";
import moment from "moment";
export default {
  props: ["productDataScope", "mainIndex", "option"],
  mixins: [mf_Mixin],
  data() {
    return {
      amt_limit: null,
      prem_limit: [{}, {}, {}, {}],
      getINVPremiumLimitTimer: null,
      getINVAmtLimitTimer: null,
      yearPremiumLimit: null,
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productDataScope.FEATURE_DATA;
    },
    amt_formatVal() {
      if (this.productDataScope.FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.productDataScope.FEATURE_DATA.amt_unit);
      }
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.productDataScope.pol_endage_tmp = this.productDataScope.pol_endage;
      this.getINVLimitRanges();
      if (this.productDataScope.premium && this.productDataScope.pay_freq) {
        this.getINVAmtLimitRanges();
      }
    },
    async getINVLimitRanges() {
      let insured_actage = this.MfEditing.insured.insured_birthday
        ? moment().diff(
            moment(this.MfEditing.insured.insured_birthday),
            "years"
          )
        : this.MfEditing.insured.insured_age;
      let {
        amt_limit,
        prem_limit,
      } = await this.$mfAPI.MFB1_0100__getINVLimitRanges({
        prod_id: this.nowProduct.prod_id,
        insured_actage: insured_actage,
        insured_age: this.MfEditing.insured.insured_age,
        insured_gender: this.MfEditing.insured.insured_gender,
      });
      this.amt_limit = amt_limit;
      this.prem_limit = prem_limit;
      this.initValidator();
    },
    async getINVAmtLimitRanges() {
      if (this.getINVAmtLimitTimer) {
        clearTimeout(this.getINVAmtLimitTimer);
      }
      this.$store.commit("update_canSave", false);
      this.getINVAmtLimitTimer = setTimeout(async () => {
        let vaild = this.productDataScope.premium
          ? await this.$validator.validate(`premium`)
          : false;
        if (vaild) {
          let insured_actage = this.MfEditing.insured.insured_birthday
            ? moment().diff(
                moment(this.MfEditing.insured.insured_birthday),
                "years"
              )
            : this.MfEditing.insured.insured_age;
          let amt_limit = await this.$mfAPI.MFB1_0100__getINVAmtLimitRanges({
            prod_id: this.nowProduct.prod_id,
            insured_actage: insured_actage,
            insured_age: this.MfEditing.insured.insured_age,
            insured_gender: this.MfEditing.insured.insured_gender,
            premium: this.productDataScope.premium,
            pay_freq: this.productDataScope.pay_freq,
          });
          this.amt_limit = amt_limit;
          if (
            parseInt(this.amt_limit.amt_floor) >
            parseInt(this.amt_limit.amt_ceil)
          ) {
            this.$mfNotice(
              "您輸入的保費依最低比率規範換算保額後，最低保額大於商品保額上限，請重新輸入較低保費。"
            );
            this.productDataScope.premium = "";
            this.getINVLimitRanges();
          }
          setTimeout(() => {
            if (this.productDataScope.amt) {
              this.$validator.validate(`amt`);
            }
          }, 50);
        } else {
          this.$store.commit("update_canSave", true);
        }
      }, 500);
    },
    initValidator() {
      Validator.extend(`amt`, {
        getMessage: "",
        validate: (value) => {
          let intValue = parseInt(value.split(",").join(""));
          //符合保額遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.amt_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.amt_incr_unit / this.amt_formatVal;
          let ceil =
            this.amt_limit.amt_ceil <= 0 ? Infinity : this.amt_limit.amt_ceil;
          return (
            (!this.amt_limit ||
              (intValue <= ceil && intValue >= this.amt_limit.amt_floor)) &&
            intValue % incr_unit === 0
          );
        },
      });
      Validator.extend(`premium`, {
        getMessage: "",
        validate: (value) => {
          if (!this.productDataScope.pay_freq) return false;
          let intValue = parseInt(value.split(",").join(""));
          //符合保費遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          let ceil =
            this.prem_limit[this.productDataScope.pay_freq].prem_ceil <= 0
              ? Infinity
              : this.prem_limit[this.productDataScope.pay_freq].prem_ceil;
          return (
            (!this.productDataScope.pay_freq ||
              (intValue <= ceil &&
                intValue >=
                  this.prem_limit[this.productDataScope.pay_freq]
                    .prem_floor)) &&
            intValue % incr_unit === 0
          );
        },
      });
    },
    converIncrUnit(number) {
      let face_prem_incr_unit =
        this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
          ? 1
          : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
      return Math.floor(number / face_prem_incr_unit) * face_prem_incr_unit;
    },
    async validateAll() {
      let VaildInput = await this.$validator.validateAll();
      return VaildInput;
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-right: 8px !important;
  line-height: 40px;
  white-space: nowrap;
}
.yearPremiumLimit {
  display: inline-block;
  padding: 5px 10px 4px;
  background-color: #fff3c2;
  font-weight: 700;
}
</style>
